export const PROCURATIONS_FILTERS_KEY = 'societario.lembretes';

// Both filters are client-side (the list is loaded once, unfiltered).
export const getDefaultProcurationsFilters = () => ({
  viewArchived: false,
  search: '',
});

// Badge: only what differs from the defaults.
export const countActiveProcurationsFilters = (filters, defaults) =>
  (!!filters.viewArchived !== !!defaults.viewArchived ? 1 : 0) +
  (filters.search ? 1 : 0);

export const filterProcurationsBySearch = (procurations, search) => {
  const s = (search || '').toLowerCase();
  return (procurations || []).filter((item) =>
    s === '' || (item.name || '').toLowerCase().indexOf(s) >= 0
  );
};
